<section header [attr.info]="site.replacesSite ? '': null">
	<menu always-visible *requiredCredential="CredentialType.ManageCompanySites; and: !site.replacesSite && site.status == siteStatusTypeEnum.Completed && notLegacySite()">
		@if (site.type == siteTypeEnum.Dsa) { <menuitem icon="copy" [disabled]="site.replacedBySite != undefined" (click)="parent.createRedesign(site)">{{ 'site.menu.create-redesign' | translate }}</menuitem> }
		@if (site.autoDeleteDate) { <menuitem icon="trash-can-clock" [disabled]="site.status == siteStatusTypeEnum.InProcessOfBeingDeleted" (click)="parent.deleteSite(site)">{{ 'site.menu.delete-site-now' | translate }}</menuitem>	}
		@else { <menuitem icon="trash-alt" [disabled]="site.replacedBySite != undefined" (click)="parent.autoDeleteSite(site)">{{ 'site.menu.delete-site' | translate }}</menuitem> }
		@if (!site.replacesSite) { <menuitem icon="lock" [disabled]="dns.getValidPointers(site).length == 0" (click)="addSsl()">{{ 'site.menu.add-ssl' | translate }}</menuitem> }
		<menuitem icon="arrow-right-arrow-left" [disabled]="selectWebsiteProductPlan?.canChange === false" (click)="showChangeProductPlan = true">{{ 'site.menu.change-product-plan' | translate }}</menuitem>
	</menu>
	<menu always-visible *requiredCredential="CredentialType.ManageCompanySites; and: site.replacesSite && site.status == siteStatusTypeEnum.Completed && notLegacySite()">
		<menuitem icon="memo-circle-check" (click)="parent.activateRedesign(site)">{{ 'site.menu.activate-redesign' | translate }}</menuitem>
		<menuitem icon="trash-alt" (click)="parent.deleteSite(site)">{{ 'site.menu.delete-redesign' | translate }}</menuitem>
	</menu>
	<menu always-visible *requiredCredential="CredentialType.ManageCompanySites; and: site.type == siteTypeEnum.AspClassic">
		<menuitem icon="trash-alt" (click)="parent.deleteSite(site)">{{ 'site.menu.delete-site' | translate }}</menuitem>
	</menu>
	<icon [attr.brand]="'GO'" [type]="siteService.getSiteIcon(site.type)" />
	<div>
		<h3 [title]="productPlan | productName">{{ siteService.getSiteName(site) }}</h3>
		@if (site.status != siteStatusTypeEnum.Failed) {
			{{ siteService.getSiteStatus(site) }} -
		}
		{{ 'site.type.' + siteTypeEnum[site.type] | translate }}
	</div>
</section>

<section [hidden]="!showChangeProductPlan">
	@if (productPlanChangeBusy) { <skeleton /> }
	@else { <select-website-product-plan [productPlanId]="productPlan.id" (productPlanIdChange)="changeProductPlan($event)" [companyId]="productPlan.companyId" /> }
	<button small ghost [loader]="false" (click)="showChangeProductPlan = false">{{ 'general.cancel' | translate }}</button>
</section>

@if (site.status != siteStatusTypeEnum.Completed && notLegacySite() && site.type != siteTypeEnum.AiBuilder) {
	<section>
		<wrapper><span>{{ 'general.status' | translate }}</span> {{ siteService.getSiteStatus(site) }}</wrapper>
		@if (site.status == siteStatusTypeEnum.Working) { <button [working]="true" [label]="'site.button.create-site' | translate"></button> }
		@if (site.status == siteStatusTypeEnum.Failed) { <button ghost [label]="'site.button.site-operation-failed' | translate" [ignoreValidation]="true" (click)="parent.deleteSite(site)"></button> }
		@if (site.status == siteStatusTypeEnum.InProcessOfBeingDeleted && !site.$deleted) { <button [label]="'site.button.delete-site' | translate" [working]="true"></button> }
	</section>
}

@if (site.type == siteTypeEnum.AiBuilder && site.status == siteStatusTypeEnum.AwaitingResponse) {
	<section>
		<button #aiBuilderButton (click)="launchAiBuilder()"><icon type="rocket-launch" /> {{ 'site.button.launch-ai-builder' | translate }}</button>
	</section>
}

@if (site.autoDeleteDate && notLegacySite()) {
	<list-view>
		<row alert statusIcon="hourglass-half" [clickable]="false">
			<column>
				<strong>{{ site.autoDeleteDate | customDate: 'daysDiffer' }}</strong> {{ 'site.deletion-timer-unit' | translate }}
				{{ 'site.deletion-date-description' | translate }}
				<strong>{{ site.autoDeleteDate | customDate: 'shortDate' }}</strong>
			</column>
			<column *requiredCredential="CredentialType.ManageCompanySites; and: site.status != siteStatusTypeEnum.InProcessOfBeingDeleted">
				<icon [title]="'site.button.cancel-deletion-tooltip' | translate" type="circle-stop" (click)="parent.cancelAutoDelete(site)" />
			</column>
		</row>
	</list-view>
}

@if (site.status == siteStatusTypeEnum.Completed) {
	<list-view emptyLabel="" [selectable]="false">
		<row *requiredCredential="CredentialType.ManageCompanySites; and: !site.replacesSite && notLegacySite() && !site.autoDeleteDate" [clickable]="false">
			<column />
			<column>
				<h3>{{ 'site.pointers' | translate }}</h3>
				<button small (click)="showAddPointer = true" [loader]="false"><icon type="plus" />{{ 'site.pointers.add-new-pointer' | translate }}</button>
			</column>
		</row>
		@if (showAddPointer) {
			<row [clickable]="false">
				<column />
				<column>
					<site-add-pointer [site]="site" (onSubmitted)="showAddPointer = false" />
				</column>
			</row>
		}
		<row [statusIcon]="pointer.primaryPointer ? 'star' : null"
			 [statusColor]="dns.getStatusColor(site, pointer)"
			 [statusTitle]="dns.getStatusText(site, pointer)"
			 *listData="let pointer from sortedSitePointers" [clickable]="false">
			<column>
				<a href="https://{{ pointer.name }}" target="_blank">{{ pointer.name }}</a>
				@if (pointer == pointerInProcessOfChangingToPrimary) { <span> {{ 'site.pointer.in-process-of-changing-to-primary' | translate }}</span> }
				@if (pointer.status != pointersStatusType.Completed) { <span> {{ 'enum.pointer-status-type.'+ pointersStatusType[pointer.status] | translate }}</span> }
			</column>
			<menu *requiredCredential="CredentialType.ManageCompanySites;">
				@if (canModifyPointer(pointer)) { <menuitem icon="star" icon-family="regular" (click)="setSitePrimaryPointer(site, pointer)">{{ 'site.menu.set-primary-pointer' | translate }}</menuitem> }
				@if (canDeletePointer(pointer)) { <menuitem icon="trash-alt" (click)="deletePointer(pointer)">{{ 'site.menu.delete-pointer' | translate }}</menuitem> }
			</menu>
		</row>
	</list-view>
}

@let newSite = site.replacedBySite;
@if (newSite && !newSite.$new && !newSite.$deleted) {
	<website-details [site]="newSite" [productPlan]="productPlan" />
}
